import { Profile, ProfileForm } from '../../Profile/types'

export const getPaymentBody = ({
  profileForm,
  profile,
}: {
  profileForm: ProfileForm
  profile: Profile
}) => ({
  cardNumber: profileForm.cardNumber.replace(/\D/g, ''),
  expirationDate: profileForm.expirationDate,
  firstName: profileForm.firstName,
  lastName: profileForm.lastName,
  address: profileForm.address,
  city: profileForm.city,
  state: profileForm.state,
  zip: profileForm.zip,
  email: profileForm.email,
  country: 'USA',
  phoneNumber: profileForm.phoneNumber,
  customerProfileId: profile.customerProfileId,
  customerPaymentProfileId: profile.customerPaymentProfileId,
  nameOnAccount: profileForm.nameOnAccount,
  routingNumber: profileForm.routingNumber,
  accountNumber: profileForm.accountNumber,
  accountType: profileForm.accountType,
})
